module.exports = __webpack_public_path__ + "static/media/hive.c79a3c6a.svg";